import React from 'react'

/**
 * Reusable status badge for master records across lists, cards, and detail views.
 */
export default function MasterApprovalStatusBadge({
  status,
  isPending = false,
  className = '',
}) {
  const norm = String(status || (isPending ? 'PENDING' : 'APPROVED')).toUpperCase()

  if (norm === 'PENDING') {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold text-amber-700 ${className}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
        Pending Review
      </span>
    )
  }

  if (norm === 'REJECTED') {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-error-container/60 px-2 py-0.5 text-[10px] font-bold text-error ${className}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-error" />
        Rejected
      </span>
    )
  }

  if (norm === 'ARCHIVED') {
    return (
      <span className={`inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium text-slate-600 ${className}`}>
        Archived
      </span>
    )
  }

  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold text-emerald-700 ${className}`}>
      Approved
    </span>
  )
}
